import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Banner from "./components/Banner";
import AboutUs from "./components/AboutUs";
import Courses from "./components/Courses";
import MissionVision from "./components/MissionVision";
import ContactSection from "./components/ContactSection";
import GallerySection from "./components/GallerySection";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

import EnquiryForm from "./pages/EnquiryForm";
import ActivitiesSection from "./pages/ActivitiesSection";
import FacilitiesSection from "./pages/FacilitiesSection";
import AboutCollege from "./pages/AboutCollege";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PrincipalMessage from "./pages/PrincipalMessage";
import TransferCertificate from "./pages/TransferCertificate";
import UgcCommittee from "./pages/UGCCommittee";

import AntiRagging from "./pages/AntiRagging";
import SexualHarassment from "./pages/SexualHarassment";
import InternalComplaints from "./pages/InternalComplaints";
import StudentGrievance from "./pages/StudentGrievance";
import RTINodalOfficer from "./pages/RTINodalOfficer";
import IQAC from "./pages/IQAC";
import OtherCells from "./pages/OtherCells";

import AdminLogin from "./admin/AdminLogin";
import AdminPanel from "./admin/AdminPanel";

function Home() {
  return (
    <>
      <Banner />
      <AboutUs />
      <Courses />
      <MissionVision />
      <ContactSection />
    </>
  );
}

function Gallery() {
  return <GallerySection />;
}

function Contact() {
  return <ContactSection />;
}

function AppContent() {
  const location = useLocation();

  const isAdminRoute =
    location.pathname === "/login" || location.pathname.startsWith("/admin");

  const hideLayoutRoutes = [
    "/anti-ragging",
    "/sexual-harassment-cell",
    "/internal-complaints-committee",
    "/student-grievance-redressal",
    "/rti-nodal-officer",
    "/iqac",
    "/other-cells",
  ];

  const hideLayout =
    isAdminRoute || hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!hideLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminPanel />} />

        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/enquiry" element={<EnquiryForm />} />
        <Route path="/activity" element={<ActivitiesSection />} />
        <Route path="/facilities" element={<FacilitiesSection />} />
        <Route path="/about-college" element={<AboutCollege />} />

        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/principal-message" element={<PrincipalMessage />} />
        <Route path="/transfer" element={<TransferCertificate />} />
        <Route path="/ugc-committee" element={<UgcCommittee />} />

        <Route path="/anti-ragging" element={<AntiRagging />} />
        <Route
          path="/sexual-harassment-cell"
          element={<SexualHarassment />}
        />
        <Route
          path="/internal-complaints-committee"
          element={<InternalComplaints />}
        />
        <Route
          path="/student-grievance-redressal"
          element={<StudentGrievance />}
        />
        <Route path="/rti-nodal-officer" element={<RTINodalOfficer />} />
        <Route path="/iqac" element={<IQAC />} />
        <Route path="/other-cells" element={<OtherCells />} />
      </Routes>

      {!hideLayout && <FloatingButtons />}
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;